import React from "react";
import PopupExpIcon from "../../Icons/PopupExpIcon";
import { Hotspot, TourData } from "../../../Types";
import { editorHotspotStore } from "../../../api/Zustand";
import { getLanguageFile } from "../../common/GetLanguageFile";

function Popup({ spot, tourData }: { spot: Hotspot; tourData: TourData }) {
  const { openHotspot, setHotspotData } = editorHotspotStore();

  return (
    <div className="popup-exp-icon">
      {
        <div className="hotspot popup">
          <PopupExpIcon
            className="popup"
            fill={spot.isNew ? "#ff8700" : "white"}
          />

          {!spot.EDIT_POS &&
            !spot.isNew &&
            tourData.popups.find((one) => one.id === spot.target) && (
              <p
                onClick={() => {
                  openHotspot(true);
                  setHotspotData(spot.target as string);
                }}
              >
                {tourData.popups.find((one) => one.id === spot.target)?.type ===
                "image"
                  ? getLanguageFile("hotspots.picture")
                  : tourData.popups.find((one) => one.id === spot.target)
                      ?.type === "video"
                  ? getLanguageFile("hotspots.video")
                  : tourData.popups.find((one) => one.id === spot.target)
                      ?.type === "text" &&
                    tourData.popups.find((one) => one.id === spot.target)?.text
                  ? getLanguageFile("hotspots.text")
                  : getLanguageFile("hotspots.pin")}
              </p>
            )}
        </div>
      }
    </div>
  );
}

export default Popup;
